import { render, staticRenderFns } from "./count-down.vue?vue&type=template&id=3b8d3894&scoped=true"
import script from "./count-down.vue?vue&type=script&lang=js"
export * from "./count-down.vue?vue&type=script&lang=js"
import style0 from "./count-down.vue?vue&type=style&index=0&id=3b8d3894&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8d3894",
  null
  
)

export default component.exports